<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <NavbarPayment></NavbarPayment>
    </div>
    <div class="row">
      <div :class="`col-lg-7 ${col_md} col-sm-12 col-xs-12 pt-0`">
        <div class="container-payment">
          <!--solo escritorios-->
          <div class="d-none d-sm-none d-md-block">
            <NavbarPayment></NavbarPayment>
          </div>
          <v-breadcrumbs :items="items">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>

          <div class="row">
            <div class="col text-center">
              <p class="color-blue font-general-r mb-2">
                El pago de tu membresía se procesara con Stripe
              </p>
              <div class="div-border-payment p-1">
                <img class="stripe" src="@/assets/store/stripe.png" alt="">
              </div>
            </div>
          </div>

          <div v-show="!is_auth" class="row mb-100">
            <div class="col mb-100">
              <p class="text-center color-blue font-general-r mb-100">
                Para continuar debes
                <router-link :to="{ path: '/iniciar-sesion', query: { ref: 'suscripcion' }}">Iniciar sesión</router-link> ó
                <router-link :to="{ path: '/registro', query: { ref: 'suscripcion' }}">Registrarte</router-link>
              </p>
            </div>
          </div>

          <div class="mb-100" v-show="is_auth">
            <div v-if="step == 'information_shipping'">
              <div class="row">
                <div class="col text-center">
                  <p class="color-blue h4 font-general-r mt-2 mb-2">DIRECCIÓN DE ENVÍO</p>

                  <div v-if="user_address.length">
                    <div class="flex-center">
                      <v-radio-group
                        v-model="new_address"
                        row
                      >
                        <v-radio
                          label="Dirección existente"
                          :value="false"
                        ></v-radio>
                        <v-radio
                          label="Nueva dirección"
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </div>

                    <v-menu offset-y v-if="!new_address">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          color="accent"
                          v-bind="attrs"
                          v-on="on"
                          class="mt-2"
                        >
                          {{ address_selected ? address_selected.full_address : 'ELIGE UNA DIRECCIÓN'}}
                          <v-icon color="primary">mdi-menu-swap</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in user_address"
                          :key="index"
                          @click="validateAddressExists(item)"
                        >
                          <v-list-item-title>{{ item.full_address }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                  </div>

                  <div v-if="!user_address.length || new_address">
                    <google-places-autocomplete
                      @resultChanged="placeDetail => getAddressData(placeDetail)"
                    >
                      <div slot="input" slot-scope="{ context, events, actions }">
                        <input
                          v-model="context.input"
                          @focus="events.inputHasReceivedFocus"
                          @input="events.inputHasChanged"
                          @keydown.enter.prevent="actions.selectItemFromList"
                          @keydown.down.prevent="actions.shiftResultsSelection"
                          @keydown.up.prevent="actions.unshiftResultsSelection"
                          type="search"
                          id="locationInput"
                          placeholder="Ingresa tu ubicación"
                          class="input-nv"
                        />
                      </div>
                    </google-places-autocomplete>
                    <!--
                    <p class="color-blue h4 font-general-r mt-2 mb-2">O</p>

                    <v-btn
                      @click="usedCurrentLocation()"
                      color="primary"
                      class="nv-btn nv-btn-large"
                      :loading="loading"
                      elevation="0"
                    >
                      UBICACIÓN ACTUAL
                      <v-icon>mdi-map-marker</v-icon>
                    </v-btn>-->
                  </div>

                  <div v-if="address.latitude && address.longitude && valid_address">
                    <form data-vv-scope="form-address">
                      <div class="row mb-5">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="name">* Nombre</label><br>
                            <input
                              v-model="address.name"
                              name="name"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="Nombre"
                              class="input-nv"
                              id="name"
                            >
                            <br>
                            <span v-show="errors.has('form-address.name')" class="text-danger mt-2">
                              {{ errors.first("form-address.name") }}
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="lastname">* Apellido</label><br>
                            <input
                              v-model="address.lastname"
                              name="lastname"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="Apellido"
                              class="input-nv"
                              id="lastname"
                            >
                            <br>
                            <span v-show="errors.has('form-address.lastname')" class="text-danger mt-2">
                              {{ errors.first("form-address.lastname") }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-5">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="street">* Calle</label><br>
                            <input
                              :readonly="!new_address || fields_disabled.street"
                              v-model="address.street"
                              name="street"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="Calle"
                              class="input-nv"
                              id="street"
                            >
                            <br>
                            <span v-show="errors.has('form-address.street')" class="text-danger mt-2">
                              {{ errors.first("form-address.street") }}
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="ext">* No. exterior</label><br>
                            <input
                              :readonly="!new_address || fields_disabled.no_outside"
                              v-model="address.no_outside"
                              name="no_exterior"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="No. exterior"
                              class="input-nv"
                              id="ext"
                            >
                            <br>
                            <span v-show="errors.has('form-address.no_exterior')" class="text-danger mt-2">
                              {{ errors.first("form-address.no_exterior") }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-5">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="int">* No. interior</label>
                            <input
                              v-model="address.no_inside"
                              name="no_inside"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="No. interior"
                              class="input-nv"
                              id="int"
                            >
                            <br>
                            <span v-show="errors.has('form-address.no_inside')" class="text-danger mt-2">
                              {{ errors.first("form-address.no_inside") }}
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="colony">* Colonia</label><br>
                            <input
                              :readonly="!new_address || fields_disabled.colony"
                              v-model="address.colony"
                              name="colony"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="Colonia"
                              class="input-nv"
                              id="colony"
                            >
                            <br>
                            <span v-show="errors.has('form-address.colony')" class="text-danger mt-2">
                              {{ errors.first("form-address.colony") }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-5">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="zip">* Código Postal</label>
                            <input
                              :readonly="!new_address || fields_disabled.zip"
                              v-model="address.zip"
                              name="zip"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="Código Postal"
                              class="input-nv"
                              id="zip"
                            >
                            <br>
                            <span v-show="errors.has('form-address.zip')" class="text-danger mt-2">
                              {{ errors.first("form-address.zip") }}
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="city">* Ciudad</label><br>
                            <input
                              :readonly="!new_address || fields_disabled.city"
                              v-model="address.city"
                              name="city"
                              v-validate="new_address ? 'required' : ''"
                              data-vv-as="Ciudad"
                              class="input-nv"
                              id="city"
                            >
                            <br>
                            <span v-show="errors.has('form-address.city')" class="text-danger mt-2">
                              {{ errors.first("form-address.city") }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                          <div class="form-group">
                            <label class="label-nv" for="phone">* Teléfono</label>
                            <input
                              v-model="address.phone"
                              name="phone"
                              v-validate="'required|numeric|digits:10'"
                              data-vv-as="Teléfono"
                              class="input-nv"
                              id="phone"
                              v-mask="mask"
                            >
                            <br>
                            <span v-show="errors.has('form-address.phone')" class="text-danger mt-2">
                              {{ errors.first("form-address.phone") }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                </div>
              </div>

              <div v-if="address.latitude && address.longitude && valid_address" class="row">
                <div class="col">
                  <v-checkbox
                    v-if="new_address"
                    v-model="address.primary_address"
                    label="Guardar como dirección principal"
                    color="primary"
                  ></v-checkbox>

                  <v-btn
                    text
                    color="primary"
                    @click="() => $router.push('/suscripciones')"
                  >
                    <v-icon left>
                      mdi-arrow-left
                    </v-icon>
                    Volver a elegir membresías
                  </v-btn>
                </div>
              </div>

              <div v-if="address.latitude && address.longitude && valid_address" class="row">
                <div class="col text-right">
                  <v-btn
                    @click="goPayment()"
                    color="primary"
                    class="nv-btn nv-btn-large nv-btn-hover"
                    :loading="loading"
                    elevation="0"
                  >
                    PROCESAR EL PAGO
                  </v-btn>
                </div>
              </div>

            </div>

            <div v-show="step == 'payment_data'">

              <div class="row">
                <div class="col text-center">
                  <p class="color-blue font-general-r mt-2 mb-2">
                    INGRESE LOS DATOS DE SU TARJETA
                  </p>
                  <div class="row">
                    <div class="col">
                      <label class="label-nv">Número de tarjeta</label>
                      <div ref="card_number" class="input-nv input-nv-padding"></div>
                      <!--<input placeholder="Número de tarjeta" v-model="card.number" name="card" v-validate="'required'" data-vv-as="Número de tarjeta" class="input-nv" id="card">
                      <br>
                      <span v-show="errors.has('card')" class="text-danger mt-2">
                        {{ errors.first("card") }}
                      </span>-->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label class="label-nv">Nombre del titular</label>
                      <input v-model="card.name" name="name" v-validate="'required'" data-vv-as="Nombre del titular" class="input-nv" id="card">
                      <br>
                      <span v-show="errors.has('name')" class="text-danger mt-2">
                        {{ errors.first("name") }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label class="label-nv">MM/AA</label>
                      <div ref="card_expiry" class="input-nv input-nv-padding"></div>
                    </div>
                    <div class="col">
                      <label class="label-nv">CVC</label>
                      <div ref="card_cvc" class="input-nv input-nv-padding"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <v-btn
                    text
                    color="primary"
                    @click="back('information_shipping')"
                  >
                    <v-icon left>
                      mdi-arrow-left
                    </v-icon>
                    Volver a información de envío
                  </v-btn>
                </div>
              </div>

              <div class="row">
                <div class="col text-right">
                  <v-btn
                    @click="payment()"
                    color="primary"
                    class="nv-btn nv-btn-large nv-btn-hover"
                    :loading="loading"
                    elevation="0"
                  >
                    PAGAR
                  </v-btn>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>

      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 d-none d-sm-none d-md-block" style="padding: 0 !important">
        <div class="container-cart-payment">
          <CartPayment/>
        </div>
      </div>
    </div>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

    <v-snackbar
      v-model="open_message"
      color="accent"
      dark
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="open_message = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="success_subscription"
      persistent
      max-width="790"
    >
      <v-card class="pa-5">
        <v-card-text>

          <div class="d-flex justify-content-center align-items-center mt-10 color-blue font-general-r">
            <img style="width: 15%; max-width: 150px; max-height: 150px" class="mr-10 d-none d-sm-none d-md-block" src="@/assets/store/iconos/bolsa.svg" alt="">
            <div class="ml-5 text-center">
              <h3>Gracias!</h3>
              <h4>Tu membresía ha sido procesada exitosamente</h4>

              <h4 class="mt-5 color-blue font-general-r">
                Los detalles de tu membresía te llegaran por email
              </h4>
            </div>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevation="0"
            class="nv-btn nv-btn-medium"
            @click="() => $router.push('/')"
          >
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PopupMessageSubscription ref="popupMessageSubscription"/>

  </div>

</template>

<script src="https://js.stripe.com/v3/"></script>
<script>
import { mapState } from 'vuex'
import SubscriptionService from '@/services/subscription.service'
import UserService from '@/services/user.service'
//import GeneralService from '@/services/general.service'
import { GooglePlacesAutocomplete } from 'vue-better-google-places-autocomplete'
//import isPointInPolygon from 'geolib/es/isPointInPolygon';
//import getDistance from 'geolib/es/getDistance'
//import convertDistance from 'geolib/es/convertDistance'
import CartPayment from '@/components/store/CartPayment'
import NavbarPayment from '@/components/store/NavbarPayment'
import FooterPayment from '@/components/store/FooterPayment'
import PopupMessageSubscription from '@/components/store/PopupMessageSubscription'

let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)

let style = {
  base: {
    iconColor: '#14365b',
    color: '#14365b',
    fontSize: '25px',
    fontFamily: 'Kanit',
    textAlign: 'center',
    fontWeight: 'bold',
    '::placeholder': {
      color: '#14365b'
    }
  }
}

export default {
  components: { GooglePlacesAutocomplete, NavbarPayment, CartPayment, FooterPayment, PopupMessageSubscription },
  data() {
    return {
      mask: [/\d/, /\d/, '', /\d/, /\d/, /\d/, /\d/, '', /\d/, /\d/, /\d/, /\d/],
      col_md: 'col-md-7',
      success_subscription: false,
      open_message: false,
      message: '',
      overlay: false,
      step: 'information_shipping',
      loading: false,
      address: {
        name: '',
        lastname: '',
        street: '',
        no_outside: '',
        no_inside: '',
        colony: '',
        zip: '',
        city: '',
        phone: '',
        primary_address: false,
        latitude: '',
        longitude: ''
      },
      card: {
        number: '',
        name: '',
        month: '',
        year: '',
        cvc: ''
      },
      items: [
        { text: 'Suscripción', disabled: false, href: '' },
        { text: 'Información de envío', disabled: true, href: '' },
        { text: 'Pago', disabled: true, href: '' }
      ],
      user_address: [],
      cardNumberElement: '',
      new_address: false,

      address_selected: null,
      coords_restricted: [],
      valid_address: true,

      fields_disabled: {
        street: false,
        no_outside: false,
        colony: false,
        zip: false,
        city: false
      }
    }
  },
  computed: {
    ...mapState(['is_auth', 'user', 'new_subscription'])
  },
  watch: {
    address_selected(newval) {
      if (newval) {
        this.address = newval
      }
    },
    new_address(newval) {
      this.address_selected = null
      this.address = JSON.parse(JSON.stringify(this.$options.data().address))
    },
    step(newval) {
      if (newval == 'payment_data') {
        this.$refs.popupMessageSubscription.openDialog()
      }
    }
  },
  methods: {
    validateAddressExists(address) {
      this.address_selected = {...address}
      this.address = {...address}
      /*if (this.address_selected) {
        this.validateLocation(this.address_selected.latitude, this.address_selected.longitude)
      }*/
    },
    getAddressData(addressData) {
      console.log(addressData)
      this.address = JSON.parse(JSON.stringify(this.$options.data().address))
      addressData.address_components.forEach(i => {
        if (i.types.length) {
          if (i.types.indexOf('postal_code') > -1) {
            this.address.zip = i.long_name
          }
          if (i.types.indexOf('locality') > -1) {
            this.address.city = i.long_name
          }
          if (i.types.indexOf('street_number') > -1) {
            this.address.no_outside = i.long_name
          }
          if (i.types.indexOf('route') > -1) {
            this.address.street = i.long_name
          }
          if (i.types.indexOf('sublocality_level_1') > -1) {
            this.address.colony = i.long_name
          }
        }
      })

      this.disabledFieldsForm()
      if (!this.validateAddressEntered()) {
        this.address.latitude = ''
        this.address.longitude = ''
        this.$swal(
          'La dirección ingresada no es valida, por favor ingresa tu dirección completa',
          'Considera colocar la calle, número de exterior y la colonia para una mejor búsqueda',
          'warning'
        )
        return false
      } else {
        this.address.latitude = addressData.geometry.location.lat()
        this.address.longitude = addressData.geometry.location.lng()
        //this.validateLocation(addressData.geometry.location.lat(), addressData.geometry.location.lng())
      }

    },
    validateAddressEntered() {
      if (this.address.city == '' || this.address.street == '' || this.address.colony == '') {
        return false
      } else {
        return true
      }
    },
    disabledFieldsForm() {
      if (this.address.zip != '') {
        this.fields_disabled.zip = true
      } else {
        this.fields_disabled.zip = false
      }
      if (this.address.city != '') {
        this.fields_disabled.city = true
      } else {
        this.fields_disabled.city = false
      }
      if (this.address.no_outside != '') {
        this.fields_disabled.no_outside = true
      } else {
        this.fields_disabled.no_outside = false
      }
      if (this.address.street != '') {
        this.fields_disabled.street = true
      } else {
        this.fields_disabled.street = false
      }
      if (this.address.colony != '') {
        this.fields_disabled.colony = true
      } else {
        this.fields_disabled.colony = false
      }

      this.fields_disabled = {...this.fields_disabled}
    },
    /*
    validateLocation(lat, lng) {
      this.loading = true
      for (let index = 0; index < this.coords_restricted.length; index++) {
        if (isPointInPolygon({
          latitude: lat,
          longitude: lng
        }, this.coords_restricted[index])) {
          this.valid_address = false
          break
        } else {
          this.valid_address = true
        }
      }
      setTimeout(() => {
        this.loading = false
        if (!this.valid_address) {
          this.$swal('Lo sentimos, no estamos disponibles para la ubicación seleccionada', '', 'warning')
        }
      }, 1000)
    },*/
    async getUserAddress() {
      this.overlay = true
      const { data:res } = await UserService.getUserAddress()
      this.user_address = res
      if (!res.length) {
        this.new_address = true
      }
      this.overlay = false
    },
    /*
    async getCoordsRestricted() {
      const { data:res } = await GeneralService.getCoordsRestricted()
      res.coords_denied.forEach(i => {
        this.coords_restricted.push([])
        i.forEach(j => {
          this.coords_restricted[this.coords_restricted.length - 1].push({
            latitude: j[0],
            longitude: j[1]
          })
        })
      })
    },*/
    generateStripe() {
      let elements = stripe.elements({
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css2?family=Kanit&display=swap'
          }
        ]
      })
      let cardNumberElement = elements.create('cardNumber', {
        style: style,
        placeholder: ''
      });
      cardNumberElement.mount(this.$refs.card_number);
      this.cardNumberElement = cardNumberElement

      let cardExpiryElement = elements.create('cardExpiry', {
        style: style,
        placeholder: ''
      });
      cardExpiryElement.mount(this.$refs.card_expiry);

      let cardCvcElement = elements.create('cardCvc', {
        style: style,
        placeholder: ''
      });
      cardCvcElement.mount(this.$refs.card_cvc);
    },
    goPayment() {
      if (this.new_address) {
        this.$validator.validateAll('form-address').then((result) => {
          if (result) {
            this.changeStep()
          } else {
            this.$swal(this.errors.items[0].msg, '', 'warning')
            return false
          }
        })
      } else {
        if (!this.address_selected) {
          this.message = 'Debes seleccionar una dirección'
          this.open_message = true
          return false
        } else {
          this.changeStep()
        }
      }
    },
    changeStep() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.step = 'payment_data'
        this.items[1].disabled = false
        window.scrollTo(0, 0)

        this.$router.replace({path: '/procesar-suscripcion', query: {step: 'pago'}})
      }, 1000)
    },
    payment() {
      this.loading = true
      let options = {
        name: this.card.name
      }
      stripe.createToken(this.cardNumberElement, options).then(res => {
        if (res.error) {
          this.loading = false
          this.$swal(res.error.message, '', 'warning')
        } else {
          this.getClientSecretStripe()
        }
      })
    },
    async getClientSecretStripe() {
      const { data:res } = await SubscriptionService.getClientSecretStripe()
      if (res.success && res.data.clientSecret) {
        this.verifiedCard(res.data.clientSecret)
      } else {
        this.loading = false
        this.$swal(res.message, '', 'warning')
      }
    },
    async verifiedCard(clientSecret) {
      const { setupIntent, error } = await stripe.confirmCardSetup(
        clientSecret, {
          payment_method: {
            card: this.cardNumberElement,
            billing_details: { name: this.card.name }
          }
        }
      );

      if (error) {
        console.log(error)
        this.loading = false
        this.$swal(error.message, '', 'warning')
      } else {
        this.storeSubscription(setupIntent.payment_method)
      }
    },
    async storeSubscription(payment_method) {
      try {
        const { data:res } = await SubscriptionService.storeSubscription({
          payment_method: payment_method,
          data_shipping: this.address,
          subscription: this.new_subscription,
          new_address: this.new_address,
          address_selected: this.address_selected
        })
        if (res.success) {
          this.$store.dispatch('setUser', res.data.user)
          this.success_subscription = true
        } else {
          this.loading = false
          this.$swal(res.message, '', 'warning')
        }
      } catch (error) {
        this.$swal('Ups, estamos teniendo algunos problemas, intenta más tarde', '', 'warning')
        this.loading = false
      }
    },
    back(step) {
      this.step = step
      this.items[1].disabled = true
      this.$router.replace({path: '/procesar-suscripcion', query: {step: 'direccion-envio'}})
    }
  },
  mounted() {
    let width = screen.width
    if (width < 960 || width >= 768) {
      this.col_md = 'col-md-12'
    }
    setTimeout(() => {
      if (this.is_auth) {
        this.address.name = this.user.name
        this.address.lastname = this.user.lastname
        this.getUserAddress()
        this.generateStripe()
      }
    }, 1000)
  }
}
</script>

<style scoped>
>>>.v-radio .v-label {
  margin-top: 10px
}
>>>.v-dialog {
  box-shadow: none;
}
>>>.vbga-results {
	background-color: #14365b;
	color: #ffffff;
	list-style: none;
	padding-left: 0;
  z-index: 1000000 !important;
  font-family: var(--font-baloo-regular);
  border-radius: 10px;
}
>>>.vbga-results li {
	padding: 5px;
}
>>>.vbga-results li:hover {
	cursor: pointer;
	background-color: #ed717c;
}
>>>.v-input__slot {
  margin-bottom: 0 !important;
}
@media only screen and (min-width: 1720px) and (max-width: 3000px) {
  .input-nv .input-nv-padding {
    padding: 30px !important
  }
}
</style>
